<div class="search-card-container">
  <div class="card-header">
    <p class="card-title">Perfil de busca: {{card.business_type ? card.business_type : ''}}</p>
    <div class="header-icons">
      <svg (click)="editClick.emit(card)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.48533 4.45739L7.54267 3.51472L1.33333 9.72406V10.6667H2.276L8.48533 4.45739ZM9.428 3.51472L10.3707 2.57206L9.428 1.62939L8.48533 2.57206L9.428 3.51472ZM2.828 12.0001H0V9.17139L8.95667 0.214722C9.08169 0.0897416 9.25122 0.0195312 9.428 0.0195312C9.60478 0.0195312 9.77432 0.0897416 9.89933 0.214722L11.7853 2.10072C11.9103 2.22574 11.9805 2.39528 11.9805 2.57206C11.9805 2.74883 11.9103 2.91837 11.7853 3.04339L2.82867 12.0001H2.828Z" fill="#ACACAC"/>
      </svg>          
      <svg (click)="removeClick.emit(card)" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.333 2.9987H13.6663V4.33203H12.333V12.9987C12.333 13.1755 12.2628 13.3451 12.1377 13.4701C12.0127 13.5951 11.8432 13.6654 11.6663 13.6654H2.33301C2.1562 13.6654 1.98663 13.5951 1.8616 13.4701C1.73658 13.3451 1.66634 13.1755 1.66634 12.9987V4.33203H0.333008V2.9987H3.66634V0.998698C3.66634 0.821887 3.73658 0.652318 3.8616 0.527293C3.98663 0.402269 4.1562 0.332031 4.33301 0.332031H9.66634C9.84315 0.332031 10.0127 0.402269 10.1377 0.527293C10.2628 0.652318 10.333 0.821887 10.333 0.998698V2.9987ZM10.9997 4.33203H2.99967V12.332H10.9997V4.33203ZM4.99967 6.33203H6.33301V10.332H4.99967V6.33203ZM7.66634 6.33203H8.99967V10.332H7.66634V6.33203ZM4.99967 1.66536V2.9987H8.99967V1.66536H4.99967Z" fill="#ACACAC"/>
      </svg>
    </div>
  </div>
  <p class="card-subtitle"><span *ngIf="card.neighborhood_or_value_zone && card.neighborhood_or_value_zone.value">{{card.neighborhood_or_value_zone.value }}, </span><span *ngIf="card.city">{{card.city + ' - '}}</span> <span class="card-state">{{ card.state }}</span></p>
  <div class="prices-container">
    <div class="price-box">
      <p class="price-box-title">Valor mínimo</p>
      <p class="price-box-value" *ngIf="card.min_cash_value ; else no_min_cash_value">{{card.min_cash_value | currency:'BRL':true:'1.2-2'}} </p>
      <ng-template #no_min_cash_value>
        <p class="price-box-value">-</p>
      </ng-template>
    </div>
    <div class="price-box">
      <p class="price-box-title">Valor máximo</p>
      <p class="price-box-value" *ngIf="card.max_cash_value ; else no_max_cash_value">{{card.max_cash_value | currency:'BRL':true:'1.2-2'}}</p>
      <ng-template #no_max_cash_value>
        <p class="price-box-value">-</p>
      </ng-template>
    </div>
  </div>
  <div class="card-icons-container">
    <div class="card-icons-item" [matTooltip]="'Metragem'">
      <lib-svg class="svg-icon" [icon]="'ruler_ico'"></lib-svg>

      <div class="area-value-text">

        <div *ngIf="!card.min_area_value && !card.max_area_value">
          <span>-</span>
        </div>

        <div *ngIf="card.min_area_value && !card.max_area_value">
          <span>A partir de {{card.min_area_value | currency:'BRL':'':'1.2-2'}} m²</span>
        </div>

        <div *ngIf="!card.min_area_value && card.max_area_value">
          <span>Até {{card.max_area_value | currency:'BRL':'':'1.2-2'}} m²</span>
        </div>

        <div *ngIf="card.min_area_value && card.max_area_value">
          <span>{{card.min_area_value | currency:'BRL':'':'1.2-2'}} a {{card.max_area_value | currency:'BRL':'':'1.2-2'}} m²</span>
        </div>

      </div>
    
    </div>
    <div class="card-icons-item" [matTooltip]="'Dormitórios'">
      <lib-svg class="svg-icon" [icon]="'bed_ico'"></lib-svg>
      <p *ngIf="card.bedrooms && card.bedrooms.length > 0 ; else no_bedrooms">{{card.bedrooms[0].value}}{{card.bedrooms.length > 1 || card.bedrooms[0].operation === 'GTE' ? '+' : ''}}</p>
      <ng-template #no_bedrooms>
        <p>-</p>
      </ng-template>
    </div>
    <div class="card-icons-item" [matTooltip]="'Suítes'">
      <lib-svg class="svg-icon" [icon]="'bed_ico'"></lib-svg>
      <p *ngIf="card.suites && card.suites.length > 0 ; else no_suites">{{card.suites[0].value}}{{card.suites.length > 1 || card.suites[0].operation === 'GTE' ? '+' : ''}}</p>
      <ng-template #no_suites>
        <p>-</p>
      </ng-template>
    </div>
    <div class="card-icons-item" [matTooltip]="'Vagas'">
      <lib-svg class="svg-icon" [icon]="'car_ico'"></lib-svg>
      <p *ngIf="card.garage_spaces && card.garage_spaces.length > 0 ; else no_garage_spaces">
        {{card.garage_spaces[0].value}}{{card.garage_spaces.length > 1 || card.garage_spaces[0].operation === 'GTE' ? '+' : ''}}
      </p>
      <ng-template #no_garage_spaces>
        <p>-</p>
      </ng-template>
    </div>
  </div>
  <p class="card-description">{{card.comments}}</p>
  <a class="card-link" (click)="linked(card.id)">Buscar imóvel</a>
</div>